import { lazyLoad } from 'utils/loadable';

export const EntityReportPage = lazyLoad(
  () => import('./index'),
  module => module.EntityReportPage
);
